import { useState, useCallback } from "react"

type Primitive = string | number | boolean | {} | []

export interface IUseValue<T extends Primitive> {
    value: T
    setValue: React.Dispatch<React.SetStateAction<T>>
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
    reset: () => void
}

/**
 * Кастомный универсальный хук для управления значением
 * - Работает с string, number, boolean
 * - Есть onChange для input/textarea/select
 * - Поддерживает reset к начальному значению
 * - Можно использовать как useState, но с бонусами
 */
export const useValue = <T extends Primitive>(
    initialValue: T,
    parser?: (value: string) => T
): IUseValue<T> => {
    const [value, setValue] = useState<T>(initialValue)

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
            const raw = e.target.value
            setValue(parser ? parser(raw) : (raw as T))
        },
        [parser]
    )

    const reset = useCallback(() => {
        setValue(initialValue)
    }, [initialValue])

    return { value, setValue, onChange, reset }
}